/*                                                          */
/*                                                          */
/*                                                          */
/*                                                     */
const BACKGROUND_FADE_DISTANCE = 80; /* */
/*                                                                                 */
const BACKGROUND_FADE_START_OFFSET = 40; /* */
const BACKGROUND_FADE_END_OFFSET = 16; /* */

/*                                                          */
/*                                                          */
/*                                                          */
const MAX_ZOOM = 1.5; /*                                          */

/*                                                          */
/*                                                          */
/*                                                          */
const BREAKPOINT_XL_WIDTH = '62rem';
const BREAKPOINT_L_WIDTH = '48rem';

export class Stage {
    constructor() {
        this.addScrollEffects();
        this.attachClickScrollToProductlistButton();
    }

    private attachClickScrollToProductlistButton(): void {
        const button = document.querySelector<HTMLElement>('.promo_staticcontent--stage-widget-button-container');
        if (!button) {
            return;
        }

        const productListParent = document.querySelector<HTMLElement>('.reptile-tile-list')?.parentElement;
        if (!productListParent) {
            return;
        }

        button.style.opacity = '1';
        button.removeAttribute('disabled');
        button.addEventListener('click', () => {
            productListParent.scrollIntoView({ behavior: 'smooth' });
        });
    }

    /**
 *
 */
    private normalize(a: number, start = 0.0, end = 1): number {
        const raw = (a - start) / (end - start);
        return Math.min(Math.max(raw, 0), 1);
    }

    private calculateImageTransformEffect(imageContainer: HTMLElement): string {
        const imageContainerRect = imageContainer.getBoundingClientRect();
        const imageContainerHeight = imageContainerRect.height;
        const imageContainerTop = imageContainerRect.top;

        /*                              */
        const visibleHeight =
            imageContainerHeight - Math.min(Math.min(imageContainerTop, 0) * -1, imageContainerHeight);
        const visibleHeightNormalizedPercents = 1 - visibleHeight / imageContainerHeight;
        const clampedScale = 1 + visibleHeightNormalizedPercents * (MAX_ZOOM - 1);

        return `scale(${clampedScale.toFixed(3)})`;
    }

    private calculateFadeOpacity(headline: HTMLElement): string {
        if (window.matchMedia(`(width >= ${BREAKPOINT_XL_WIDTH})`).matches) {
            return '1';
        }

        /*             */
        const headlineHeight = headline.getBoundingClientRect().top;
        const fadeStartOffset = BACKGROUND_FADE_DISTANCE - BACKGROUND_FADE_START_OFFSET;
        const fadeEndOffset = BACKGROUND_FADE_END_OFFSET - BACKGROUND_FADE_START_OFFSET;
        const transparency = this.normalize(headlineHeight, fadeStartOffset, fadeEndOffset);
        return (1 - transparency).toFixed(3);
    }

    private addScrollEffects(): void {
        const imageContainer = document.querySelector<HTMLElement>(
            '.promo_staticcontent--stage-widget-picture-container',
        );
        const image = document.querySelector<HTMLElement>('.promo_staticcontent--stage-widget-image');
        const headline = document.querySelector<HTMLElement>('.promo_staticcontent--stage-widget-headline');

        if (!headline || !imageContainer || !image) {
            return;
        }

        window.addEventListener(
            'scroll',
            () => {
                const top = imageContainer.getBoundingClientRect().top;
                if (top < 0 && window.matchMedia(`(width < ${BREAKPOINT_L_WIDTH})`).matches) {
                    /*                            */
                    imageContainer.style.height = `${image.clientHeight}px`;
                    image.style.position = 'fixed';
                    image.style.transform = this.calculateImageTransformEffect(imageContainer);
                } else {
                    /*                                                 */
                    imageContainer.style.height = 'auto';
                    image.style.position = 'relative';
                    image.style.transform = 'none';
                }

                imageContainer.style.opacity = this.calculateFadeOpacity(headline);
            },
            { passive: true },
        );
    }
}
